import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IOfficeInfo } from 'src/app/core/interfaces/IOfficeItem.interface';
import Utils from 'src/app/shared/utilities/utils';
import { AppVersionService } from 'src/app/core/services/app-version.service';
import { LoggingService } from 'src/app/core/services/logging.service';
import { PreferredOfficeDataService } from 'src/app/core/services/data/preferred-office.data.service';
import { IResourcesCardData } from 'src/app/core/interfaces/IResourcesCard.interface';
import { BrowserService } from 'src/app/core/services/browser-service';
import { DeviceService } from 'src/app/core/services/device.service';

@Component({
    selector: 'app-help-and-support',
    templateUrl: './help-and-support.page.html',
    styleUrls: ['./help-and-support.page.scss'],
    standalone: false
})
export class HelpAndSupportPage implements OnInit, OnDestroy {
  public appVersion: string = '';
  public isMobile: boolean = false;
  private subscriptionList: Subscription[] = [];

  constructor(
    private appVersionService: AppVersionService,
    private loggingService: LoggingService,
    private preferredOfficeDataService: PreferredOfficeDataService,
    private browserService: BrowserService,
    private deviceService: DeviceService
  ) {
    this.isMobile = this.deviceService.isMobile();
  }

  public get preferredOffice(): IOfficeInfo {
    return this.preferredOfficeDataService.preferredOffice.getValue();
  }

  public get FAQData(): IResourcesCardData {
    return {
      text: `Check out LibertyTax.com for answers to common questions and
      resources to help you when filing your taxes`,
      headerText: 'FAQ & RESOURCES',
      buttonText: 'GO TO RESOURCES',
      icon: '/assets/icon/rebrand/Idea-Icon.svg',
      dark: false,
      buttonRoute: 'https://www.libertytax.com/tax-resources/',
      externalLink: true,
      style: {
        minHeight: this.isMobile ? null : '110px'
      }
    };
  }

  public get ContactData(): IResourcesCardData {
    const message: string = this.preferredOffice
      ? 'Contact your Liberty Office by phone number, e-mail, or text!'
      : 'Click below to be automatically connected to your nearest office based on your current location.';

    const button: string = this.preferredOffice
      ? 'GO TO MY OFFICE'
      : 'GET CONNECTED';

    return {
      text: message,
      headerText: 'CONTACT',
      buttonText: button,
      ionIcon: 'call-outline',
      dark: false,
      buttonRoute: '/my-office',
      style: {
        minHeight: this.isMobile ? null : '110px'
      }
    };
  }

  ngOnInit() {
    this.subscriptionList.push(
      this.appVersionService.getVersionNumber().subscribe(
        (version) => {
          this.appVersion = version;
        },
        (err) => {
          this.loggingService.logException(err);
        }
      )
    );
  }

  ngOnDestroy() {
    if (Utils.isArrayWithLength(this.subscriptionList)) {
      this.subscriptionList.forEach((s) => s.unsubscribe());
    }
  }
}
